import parsePhoneNumber from 'libphonenumber-js';

export function getFormattedPhoneNumber(number: string) {
  try {
    const phoneNumber = parsePhoneNumber(number);
    return phoneNumber ? phoneNumber.formatInternational() : number;
  } catch {
    return number;
  }
}
